var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.226756 0.225704C0.501612 -0.0478766 0.931716 -0.0727475 1.2348 0.151091L1.32163 0.225704L8 6.87273L14.6784 0.225704C14.9532 -0.0478766 15.3833 -0.0727475 15.6864 0.151091L15.7732 0.225704C16.0481 0.499284 16.0731 0.927393 15.8482 1.22907L15.7732 1.3155L8.54744 8.50777C8.27258 8.78135 7.84248 8.80622 7.53939 8.58238L7.45256 8.50777L0.226756 1.3155C-0.0755853 1.01456 -0.0755853 0.526642 0.226756 0.225704Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7732 15.7743C15.4984 16.0479 15.0683 16.0727 14.7652 15.8489L14.6784 15.7743L8 9.12727L1.32163 15.7743C1.04677 16.0479 0.616671 16.0727 0.313588 15.8489L0.226756 15.7743C-0.0480993 15.5007 -0.0730866 15.0726 0.151795 14.7709L0.226756 14.6845L7.45256 7.49223C7.72742 7.21865 8.15752 7.19378 8.46061 7.41762L8.54744 7.49223L15.7732 14.6845C16.0756 14.9854 16.0756 15.4734 15.7732 15.7743Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseFlow);
export default __webpack_public_path__ + "static/media/icon-close-flow.0189dfe71fb00b03f7569f8b4a51f1d3.svg";
export { ForwardRef as ReactComponent };